import { IconButton } from '@chakra-ui/react';

import { IconClose } from '../../../../common/design-tokens/Icons';
import SVGWrapper from '../Utility/SVGWrapper';

interface Props {
  onClose?: () => void;
}

const CloseButton = ({ onClose }: Props) => (
  <IconButton
    aria-label="Close"
    color="inherit"
    icon={<SVGWrapper icon={<IconClose />} />}
    variant="link"
    onClick={onClose}
  />
);

export default CloseButton;
